export default "__VITE_ASSET__BWghk5Ep__"